import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// Database types
export interface Profile {
  id: string
  user_id: string
  quiet_mode: boolean
  low_stim_mode: boolean
  created_at: string
  updated_at: string
}

export interface MindfulSession {
  id: string
  user_id: string
  responses: Record<string, string>
  generated_poem?: string
  session_date: string
  created_at: string
}

export interface GratitudeEntry {
  id: string
  user_id: string
  content: string
  prompt: string
  entry_date: string
  created_at: string
}

export interface MoodCheckin {
  id: string
  user_id: string
  mood: string
  responses?: Record<string, any>
  checkin_date: string
  created_at: string
}